import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    class: "vertical-splitter-resizer",
    id: "vertical-splitter-div"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_b_tooltip = _resolveDirective("b-tooltip");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.hideLeftPanel)
            ? _withDirectives((_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "hide-show-button",
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.hideShowLeftPanel && _ctx.hideShowLeftPanel(...args))),
                title: "Show/hide filter panel"
            }, [
                _createElementVNode("i", {
                    "aria-hidden": "true",
                    class: _normalizeClass(['fa', _ctx.leftPanelVisible ? 'fa-chevron-left' : 'fa-chevron-right'])
                }, null, 2 /* CLASS */)
            ])), [
                [
                    _directive_b_tooltip,
                    void 0,
                    void 0,
                    { hover: true }
                ]
            ])
            : _createCommentVNode("v-if", true)
    ]));
}
